import * as React from 'react';

import { Formatters } from '../../../codegen/Localize';
import { FavoriteToggle } from '../../../common/react/components/FavoriteToggle/FavoriteToggle';
import { FlowDetailWithUsageInfo } from '../../../ts/models/FlowInfo';

export class FlowPlaceHeaderParts {
  constructor(
    private readonly flowInfo: FlowDetailWithUsageInfo,
    private readonly onAddFavorite: () => void,
    private readonly onRemoveFavorite: () => void
  ) { }

  public favorites(): JSX.Element {
    const favoritesTotal = this.flowInfo.usageInfo ? this.flowInfo.usageInfo.favoritesTotal : 0;
    return (
      <span>
        <span className="tb-place-favorite" data-tb-test-id="favorite-toggle">
          <FavoriteToggle isFavorite={this.flowInfo.favorite}
            onAddFavorite={this.onAddFavorite}
            onRemoveFavorite={this.onRemoveFavorite}
            canHaveKeyboardFocus={true} />
        </span>
        <span className="tb-place-description-line-favorites">{Formatters.formatCount(favoritesTotal)}</span>
      </span>
    );
  }
}
